// extracted by mini-css-extract-plugin
export default {"Container":"Tension_Container__EELe-"};